import { render, staticRenderFns } from "./StateParetoChart.vue?vue&type=template&id=27b3bb60&scoped=true&"
import script from "./StateParetoChart.vue?vue&type=script&lang=js&"
export * from "./StateParetoChart.vue?vue&type=script&lang=js&"
import style0 from "./StateParetoChart.vue?vue&type=style&index=0&id=27b3bb60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3bb60",
  null
  
)

export default component.exports